import logger from 'logger/logHelper';
import { NetworkService } from './network.service';
import dexieService from './offlineServices/dexie.service';
import { getCurrentUser,clearLocalData } from '../utils.js';
import NativeJSInterface from 'common/NativeInterface/NativeJSInterface';
const NativeJSInterfaceInstance = new NativeJSInterface();

class LoginApi {
  /**
   * @description This will help you to login on SmartServ crm server
   * @param {*} email
   * @param {*} password
   *
   * @returns {Promise}
   */
  login(email, password, rememberMe) {
    try {
      const params = {
        username: email,
        password,
        rememberMe: rememberMe || false
      };
      return NetworkService.post('api/auth/login', params);
    } catch (error) {
      logger.logError(error);
      console.log(error);
    }
  }

  /**
   * @description This api will help you to logout the user
   */
  static logout() {
    const user = getCurrentUser();
    if(!user || !user.id){
      return;
    }
    const accessToken = localStorage.getItem('access-token');
    // let refreshToken = localStorage.getItem("refresh-token");
    return NetworkService.post('api/auth/logout', {
      accessToken,
      // refreshToken,
      userId: user.id
    });
  }

  /**
   * @description This will return the login state with the help of session token from local storage
   */
  getLoginState() {
    return !!localStorage.getItem('access-token');
  }

  forgotPassword(email) {
    const url = `api/auth/forgotpassword`;
    return NetworkService.post(url, { username: email });
  }

  subscribeToNotifications(subscription) {
    return NetworkService.post('api/meta/subscribe', { subscription });
  }

  getCurrentSubscription() {
    return NetworkService.get('api/meta/subscription');
  }

  static checkLoginState() {
    const url = 'api/auth/validateToken';
    return NetworkService.get(url);
  }
   
  static clearAndRedirectToLogin(){
    clearLocalData();
    window.location.href = "/";
  }

  static async callLogout(hrefPath) {
    try {
      await LoginApi.logout();
    } catch (error) {
      console.log(error);
      throw error;
    };
    const nativeCallSuccess = NativeJSInterfaceInstance.logout();
    if (nativeCallSuccess) {
      logger.logInfo('Native logout success!');
    } else {
      clearLocalData();
    }
    if (hrefPath) {
      window.location.href = hrefPath;
    }
    return true;
  }
}

export default LoginApi;
